import { useStore } from '../state/RootStore'
import { observer } from 'mobx-react-lite'
import Select from '../components/Select'
import { values } from 'mobx'
import { useConfirm } from '../utils'
import Hr from '../components/Hr'
import Button, { BUTTON_SIZE_MEDIUM, BUTTON_STYLE_DELETE } from '../components/Button'
import PlayerForm from '../components/PlayerForm'
import { ToastContainer } from 'react-toastify'

const PlayerSelect = observer(() => {
    const rootStore = useStore()
    const { entityStore, playerEditStore } = rootStore

    if (playerEditStore.isNew) {
        return null
    }

    return <Select
        className='min-w-[400px] !mb-0'
        name='event'
        options={values(entityStore.players).map(player => ({
            key: player.id,
            value: `/${player.slug} - ${player.title}`,
        }))}
        value={rootStore.selectedPlayerId}
        onChange={value => {
            rootStore.setPlayer(parseInt(value))
        }}
    />
})

const DeletePlayerButton = observer(() => {
    const { playerEditStore } = useStore()
    const { confirm, isPending } = useConfirm(() => {
        playerEditStore.delete()
    })

    if (playerEditStore.isNew) {
        return null
    }

    return <Button
        onClick={(e) => {
            e.stopPropagation()
            confirm()
        }}
        size={BUTTON_SIZE_MEDIUM}
        style={BUTTON_STYLE_DELETE}
    >{isPending ? 'Are you sure?' : 'Delete'}</Button>
})

const CancelCreatePlayerButton = observer(() => {
    const { playerEditStore } = useStore()
    const { confirm, isPending } = useConfirm(() => {
        playerEditStore.cancel()
    })

    if (!playerEditStore.isNew) {
        return null
    }

    return <Button
        onClick={(e) => {
            e.stopPropagation()
            confirm()
        }}
        size={BUTTON_SIZE_MEDIUM}
        style={BUTTON_STYLE_DELETE}
    >{isPending ? 'Are you sure?' : 'Cancel'}</Button>
})

const CreatePlayerButton = observer(() => {
    const rootStore = useStore()
    const { playerEditStore } = rootStore

    if (playerEditStore.isNew) {
        return null
    }

    return <Button onClick={(e) => {
        e.stopPropagation()

        playerEditStore.create({
            id: -1,
        })
    }} size={BUTTON_SIZE_MEDIUM}>Create</Button>
})

function LogOutButton() {
    const rootStore = useStore()
    const { confirm, isPending } = useConfirm(() => {
        rootStore.logout()
    })

    return <Button
        onClick={(e) => {
            e.stopPropagation()
            confirm()
        }}
        size={BUTTON_SIZE_MEDIUM}
        style={BUTTON_STYLE_DELETE}
    >{isPending ? 'Are you sure?' : 'Log out'}</Button>
}

function DashboardContainer() {
    return <div className=''>
        <div className='flex flex-col'>
            <div className='flex justify-between px-10 py-4'>
                <div className='flex items-center gap-2 justify-center'>
                    <PlayerSelect />
                    <DeletePlayerButton />
                    <CreatePlayerButton />
                    <CancelCreatePlayerButton />
                </div>

                <div className='flex items-center ml-auto'>
                    <LogOutButton />
                </div>
            </div>

            <Hr />

            <PlayerForm />

        </div>

        <ToastContainer />
    </div>
}

export default observer(DashboardContainer)
